<div class="create-file-dialog">
   <sync-dialog
      [config]="{title: 'New file', isClosable: true, actionButton: 'Create', cancelButton: 'Cancel',onActionClick: createDocument,onCancelClick: closeDialog,isActionButtonDisabled: errors.length > 0,
      isButtonLoading: isActionButtonLoading }"
      [open]="showDialog" [isFullScreen]="false" [onClose]="closeDialog">
      <div class="file-create-container">
         <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
         <div class="file-type-container">
           <div class="caption">
               File type
            </div>
            <div class="file-type">
               <ng-container *ngFor="let doc of documents">
                  <div class="file-type-card" [class.selected]="selectedDocType === doc.extension" (click)="selectedDocType=doc.extension; onSelectDocType(doc.extension)">
                    <sync-icon [name]="doc.icon" iconSize="large"></sync-icon>
                    <div class="text-wraper">
                       <div class="text body-1">
                          {{doc?.shortName}}
                       </div>
                       <div class="sub-text caption">
                          *{{doc?.extension}}
                       </div>
                    </div> 
                  </div>
               </ng-container>
            </div>
         </div>
         <sync-text-field #fileNameInput [label]="'File name'" [value]="fileName" [inputChange]="fileNameChange"
            [maxValue]="maxFileNameLength" [errorMessage]="invalidFileNameError"></sync-text-field>
         <div class="secured">
            <sync-icon iconSize="small" name="lock-encrypted"></sync-icon>
            Secured by Sync
         </div>
      </div>
   </sync-dialog>
</div>